export default {
  'price.title': 'מחיר',
  'price.originalPrice': 'מחיר מקורי',
  'price.currency': 'מטבע',
  'price.originalPriceError': 'מחיר מקורי נדרש',
  'price.discountedPrice': 'מחיר עם הנחה',
  'price.discountBy': 'הנחה ב־',
  'price.discountedCalc': 'יחושב',
  'price.discounted': 'בהנחה?',
  'price.trialed': 'תקופת ניסיון?',
  'price.duration': 'משך תשלום',
  'price.durationPeriod': 'תקופה',
  'price.discount': 'הנחת תשלום',
  'price.trialedDiscount': 'הנחת תקופת ניסיון',
  'price.discountInfo': 'פרטי הנחה {{header}}',
  'price.discountStartedAt': 'התחיל ב־',
  'price.discountDuration': 'משך הנחה',
  'price.trial': 'ניסיון',
  'price.sale': 'מבצע',
  'price.saleAt': 'התחלת / סיום מבצע',
  'price.trialDuration': 'משך תקופת ניסיון',
  'price.trialPriceInfo': 'תקופת ניסיון',
  'price.priceInfo': 'פרטי מחיר {{type}}',
  'price.info.helper':
    'קבע מחיר מקורי, בחר מטבע, החל הנחות והגדר פרטי תקופת ניסיון',
};
